import React from "react";
import { StandardComp } from "../atoms/standardComp";
import { SubTextAtom, TextAtom } from "../atoms/TextAtom";
import { IconGroup } from "../atoms/buttons";
import { IconUsersGroup, IconAdjustments, IconPencil, IconCalendar, IconBook  } from "@tabler/icons-react";
import { HorizontalLayout, VerticalLayout } from "../components/layout";
import { Badge } from "../atoms/badges";
import { IconTextMolecule } from "./IconTextMolecule";
import { Chip } from "./Chip";
import { useState } from "react";
import { IconText } from "../components/courseComp";
import { ActivityButton, TaskModalButton } from "../components/campagne";
import { FaseModal } from "../components/customModals";
import { AddLeadToTask, AddTask, AddTaskToLead, TaskModal } from "../components/taskModal";

export function ProjectCard({title, afdeling, cursus, status, beginDatum, eindDatum, open}) {

  const [expanded, setExpanded] = useState(false);
  const afdelingArray = typeof afdeling === "string" ? afdeling.split(",").map((d) => d.trim()) : Array.isArray(afdeling) ? afdeling : [];
  const visibleAfdelingen = expanded ? afdelingArray : afdelingArray.slice(0, 3);
  const [modalVisible, setModalVisibile] = useState(false)
  const [taskModalVisible, setTaskModalVisibile] = useState(false)
  



    const showModal = () => {
      setModalVisibile(true)
    }    
    
    const showTaskModal = () => {
      setTaskModalVisibile(true)
    }

  return (
          <>
            {modalVisible &&
              <FaseModal
                visible={modalVisible}
                type={"campagne"}
                title={"Campagne"}
                dismiss={() => setModalVisibile(false)}
                // stepId={stepId}
              />
            }

      {taskModalVisible && (
        <AddTask visible={taskModalVisible} dismiss={() => setTaskModalVisibile(false)}/>
        // <AddLeadToTask visible={taskModalVisible} dismiss={() => setTaskModalVisibile(false)} leads={["Marendsly Innocente", "Jaleel Bito"]}/>
        // <AddTaskToLead visible={taskModalVisible} dismiss={() => setTaskModalVisibile(false)} lead={"Marendsly Innocente"} />        
      )}


    <StandardComp
      editClass={"project-comp standard-shadow"}
      onClick={open}
      style={{ padding: "0", height: "100%", width: "100%" }}
      content={
        <VerticalLayout
          onClick={open}
          style={{
            width: "auto",
            height: "auto",
            maxHeight: "100%",
          }}
          className="small-standard-padding"
        >
          <HorizontalLayout
            className="space-between"
            style={{
              borderBottom: "1px solid var(--border-color)",
              paddingBottom: ".5rem",
            }}
          >
            <TextAtom
              title={title}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
            <Badge
              style={{ margin: "0" }}
              badge={status.toLowerCase()}
              rounded={true}
              label={status}
            />
          </HorizontalLayout>

          <VerticalLayout onClick={open} style={{ justifyContent: "flex-end" }}>
            <IconTextMolecule
              icon={<IconCalendar size={16} color="var(--standard-text-color)" />}
              text={
                <SubTextAtom
                  title={
                    beginDatum === "-" && eindDatum === "-"
                      ? "Geen datum"
                      : `${beginDatum} - ${eindDatum}`
                  }
                />
              }
            />

            <IconTextMolecule
              icon={<IconBook size={16} color="var(--standard-text-color)" />}
              text={
                <Chip
                  label={`${cursus} cursussen`}
                  variant="default"
                  size="small"
                  style={{
                    backgroundColor: "var(--primary-50)",
                    color: "var(--primary-900)",
                    padding: "0.2rem 0.5rem",
                    fontSize: "0.85rem",
                    userSelect: "none",
                  }}
                />
              }
            />
            <IconTextMolecule
              icon={<IconUsersGroup size={16} color="var(--standard-text-color)" />}
              text={
                <HorizontalLayout
                  style={{
                    display: "flex",
                    gap: "0.25rem",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingRight: "0.7rem"
                  }}
                >
                  {Array.isArray(afdelingArray) && afdelingArray.length > 0 ? (
                    <>
                      {visibleAfdelingen.map((item, index) => (
                        <Chip
                          key={item}
                          label={item}
                          variant="default"
                          size="small"
                          style={{
                            backgroundColor: "var(--primary-50)",
                            color: "var(--primary-900)",
                            userSelect: "none",
                          }}
                        />
                      ))}
                      {afdelingArray.length > 3 && (
                        <span
                        className="chip"
                          onClick={(e) => { e.stopPropagation(); setExpanded(!expanded);}}
                          style={{
                            backgroundColor: "var(--primary-50)",
                            color: "var(--primary-900)",
                            userSelect: "none",
                            fontSize: "12px"
                          }}
                        >
                          {expanded ? "Toon minder" : "..."}
                        </span>
                      )}
                  </>
                  ) : (
                    <Chip
                      label="Leeg"
                      variant="default"
                      size="small"
                      style={{
                        color: "var(--standard-text-color-light)",
                      }}
                    />
                    
                  )}

                    <ActivityButton onClick={(e) => { e.stopPropagation(); showModal();}} 
                    size={18}
                    backgroundColor="var(--grey-300)"
                    textColor={"black"}
                    tooltipBackground="var(--grey-300)"
                    iconColor
                    visibility={"visible"}
                    />
                    
                    <TaskModalButton onClick={(e) => { e.stopPropagation(); showTaskModal();}} 
                    size={18}
                    backgroundColor="var(--grey-300)"
                    textColor={"black"}
                    tooltipBackground="var(--grey-300)"
                    iconColor
                    visibility={"visible"}
                    />

                </HorizontalLayout>
              }
            />
          </VerticalLayout>
        </VerticalLayout>
      }
    />
    </>
  );
}
